import * as React from "react"

import { cn } from "../../lib/utils"

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    (<input
      type={type}
      className={cn(
        "tw-flex tw-h-9 tw-w-full tw-text-black tw-rounded-[4px] tw-shadow-none tw-border-none tw-border-input tw-bg-[#F2F2F2] tw-px-3 tw-py-1 tw-text-sm tw-transition-colors file:tw-border-0 file:tw-bg-transparent file:tw-text-sm file:tw-font-medium file:tw-text-foreground placeholder:tw-text-muted-foreground focus-visible:tw-outline-none focus-visible:tw-ring-1 focus-visible:tw-ring-[#00B5ED] disabled:tw-cursor-not-allowed disabled:tw-opacity-50",
        className
      )}
      ref={ref}
      {...props} />)
  );
})
Input.displayName = "Input"

export { Input }
